import React from 'react';
import Typography from 'components/CustomTypography';

function MakeModelYearField({ record }) {
  const { make = '', model = '', year = '' } = record;
  return <Typography variant="body2">{`${make} ${model} ${year}`}</Typography>;
}

export default MakeModelYearField;
